var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDrivingDistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5c.613 0 1.14.362 1.372.886l.048.124L21 12v8c0 .51-.388.935-.884.993L20 21h-1c-.51 0-.935-.388-.993-.884L18 20v-1H6v1c0 .51-.388.935-.884.993L5 21H4c-.51 0-.935-.388-.993-.884L3 20v-8l2.08-5.99c.195-.548.683-.95 1.28-1.004L6.5 5h11zM5 12.789V17h14v-4.21c-4.668-1.053-9.33-1.053-14-.001zM7.5 13c.83 0 1.5.67 1.5 1.5S8.33 16 7.5 16 6 15.33 6 14.5 6.67 13 7.5 13zm9 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm.646-6H6.853l-1.257 3.62c4.268-.827 8.54-.827 12.808.001L17.146 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrivingDistance);
export default __webpack_public_path__ + "static/media/icon-driving-distance.fceaf80bb418f031922b08d6bdb0d3f9.svg";
export { ForwardRef as ReactComponent };